import React from 'react'

export default function IconStar({className}) {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.875 0L10.1101 5.04871L15.6023 5.61424L11.4914 9.30004L12.6508 14.6983L7.875 11.9275L3.09924 14.6983L4.25861 9.30004L0.147666 5.61424L5.63995 5.04871L7.875 0Z" fill="currentColor"/>
    </svg>
  )
}
